import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './detail.css';

const STATE = {
  done: { icon: 'ri-checkbox-circle-fill', label: 'Done' },
  open: { icon: 'ri-error-warning-line', label: 'Open' },
  na: { icon: 'ri-checkbox-blank-circle-line', label: 'Not started' },
};

const stateKey = done => {
  if (done === true) return 'done';
  if (done === false) return 'open';
  return 'na';
};

/**
 * Step checklist with an overall bar. `steps` = [{ id, label, done }] where
 * done is true / false / null (unknown). Pass `onSelect` to make steps jump to
 * the matching tab.
 */
const ProgressChecklist = ({ steps, activeId, onSelect }) => {
  const doneCount = steps.filter(step => step.done === true).length;
  const percent = steps.length
    ? Math.round((doneCount / steps.length) * 100)
    : 0;

  return (
    <div>
      <div className='d-flex justify-content-between small text-muted mb-1'>
        <span>
          {doneCount} of {steps.length} completed
        </span>
        <span>{percent}%</span>
      </div>
      <div
        className='dt-progress'
        role='progressbar'
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label='Completion'
      >
        <div className='dt-progress__bar' style={{ width: `${percent}%` }} />
      </div>
      <ul className='dt-steps'>
        {steps.map(step => {
          const key = stateKey(step.done);
          const Tag = onSelect ? 'button' : 'div';
          const interactive = onSelect
            ? { type: 'button', onClick: () => onSelect(step.id) }
            : {};
          return (
            <li key={step.id}>
              <Tag
                {...interactive}
                className={classnames('dt-step', `is-${key}`, {
                  'is-active': activeId === step.id,
                })}
              >
                <i
                  className={`dt-step__icon ${STATE[key].icon}`}
                  aria-hidden='true'
                />
                <span className='dt-step__label'>{step.label}</span>
                <span className='dt-step__state'>{STATE[key].label}</span>
              </Tag>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

ProgressChecklist.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      done: PropTypes.bool,
    })
  ).isRequired,
  activeId: PropTypes.string,
  onSelect: PropTypes.func,
};

export default ProgressChecklist;
